<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Reports in Progress</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <b-spinner class="center-spinner" v-if="!loaded" variant="primary" label="Spinning"></b-spinner>
                        <b-table v-if="loaded" striped hover :items="response" show-empty="true" empty-text='There are no records to show'
                                 :fields="['ReportName','Type','Status','ReimbursementTotal','Action','CreatedBy']">
                            <template v-slot:cell(ReportName)="data">
                                <span v-html="data.value"></span>
                            </template>
                            <template v-slot:cell(SubmittedDate)="data">
                                {{data.value | formatDate}}
                            </template>
                            <template v-slot:cell(ReimbursementTotal)="data">
                                {{data.value | currency}}
                            </template>
                            <template v-slot:cell(Action)="data">
                                <div v-if="data.item.StatusId == 1">
                                    <font-awesome-icon class="icons cursor-pointer" icon="trash" @click="deleteExpenseReport(data.item.ExpenseReportId)" />
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ReportService from '@/services/ReportService'
    import UserService from '@/services/UserService';

    export default {
        async created() {
            this.response = await ReportService.getReportsInProgress(this.$route.params.admin);
            this.loaded = true;
        },
        data() {
            return {
                response: null,
                loaded: false
            }
        },
        methods: {
            async deleteExpenseReport(erID) {
                if (confirm('Are you sure you want to delete this expense report?')) {
                    try {
                        await ReportService.deleteExpenseReport(erID);
                        this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Expense Report deleted." });
                        this.response = await ReportService.getReportsInProgress();
                    } catch (e) {
                        this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                    }
                }
            }
        }
    }
</script>